import { AfterViewInit, Component, OnInit } from "@angular/core";
import { NotificationsService } from "../_services/notifications.service";
import { count, firstValueFrom } from "rxjs";
import { Notification } from "../_types/notification";
import { IParamsCollection } from "src/app/core/jsonapi/interfaces/params-collection";
import { ChatService } from "../../chat/_services/chat.service";
import { Router } from "@angular/router";
import { SidebarService } from "src/app/core/sidebar/sidebar.service";
import { FilterBuilder } from "src/app/core/jsonapi/filters-builder";
import { AndFilter, Filter, FilterOperation, NotFilter, OrFilter } from "src/app/core/jsonapi/filter";
import { NotificationsTypesService } from "../_services/notifications-types.service";
import { LocalStorageService } from "angular-web-storage";
import { ContractProcessorsService } from "../../companies/_services/contracts-processors.service";
import { WhatsappChatService } from "../../whatsapp/_services/whatsapp-chat.service";

@Component({
    selector: 'app-notifications-sidebar',
    templateUrl: './notifications-sidebar.component.html',
    styleUrls: ['./notifications-sidebar.component.scss'],
    standalone: false
})
export class NotificationsSidebarComponent {

    public user: any = {};
    public notifications: Notification[] = [];

    public notificationTypes:any[] = [];
    public usersSameContractsIds: any[] = [];
    public filters: any = {
            readedAt: new Filter(FilterOperation.equals, 'readedAt', '', null, true),
            web: new Filter(FilterOperation.equals, 'web', '', true),
            userId: new Filter(FilterOperation.any, 'userId', ''),            
            source: new NotFilter(FilterOperation.equals, 'source', '', 'Chat')
        };

    constructor(
        private storage: LocalStorageService,
        private notificationsTypesService: NotificationsTypesService,
        private notificationsService: NotificationsService,
        private chatService: ChatService,
        private router: Router,
        private contractProcessorsService: ContractProcessorsService,
        private whatsappChatService: WhatsappChatService,

    ) {
        this.notificationTypes = this.notificationsTypesService.all();
        this.notificationsService.onShowSidebar.subscribe((visible:boolean) => {
            this.loadUserData();
            this.notifications = [];
            if(visible){
               // this.loadNotifications();
               this.loadProcessorContracts();
            }
        });
    }

    loadUserData(){
        let user = this.storage.get("user");
        if(user) this.user = this.storage.get("user");
    }

    
  async loadProcessorContracts(){
    //Se busca la información del combo de la pantalla
    let filterP: any = {
      processorId: new Filter(FilterOperation.equals, 'processorId', '', this.user.id)
    };
    let paramsP:IParamsCollection = {
      filter: FilterBuilder.fromObject(filterP).build()
    };
    let responseP = await firstValueFrom(this.contractProcessorsService.all(paramsP));
    let processorContractIds = responseP.data.map(pc => pc.contractId);

    //los tramitadores de los mismos contratos que el usuario
    let filtersCases = {
      contractId: new Filter(FilterOperation.any, 'contractId', "", processorContractIds)        
    };  
    let paramsCases: IParamsCollection = { page: { number: 1, size: 2000}}
    //creamos filtros
    paramsCases.filter = FilterBuilder.fromObject(filtersCases).build();
    var contractProcessorsAll = await firstValueFrom(this.contractProcessorsService.all(paramsCases)).then(response => response.data);
    
    this.usersSameContractsIds = contractProcessorsAll.filter((v, i, a) => a.findIndex(t => (t.processorId === v.processorId)) === i).map(cp => cp.processorId);

    //añadimos a el mismo
    //this.usersSameContractsIds.push(this.user.id as string);
    this.loadNotifications();
       
  }

    async loadNotifications() {

        //filtro de gente ausente
        if(this.usersSameContractsIds.length>0){
             this.filters['userId'] = new OrFilter([
                new Filter(FilterOperation.equals, 'userId', '', this.user.id),
                new AndFilter([
                    new Filter(FilterOperation.equals, 'user.absence', '', true),
                    new Filter(FilterOperation.any, 'userId', '', (this.usersSameContractsIds.length>0?this.usersSameContractsIds:null))
                ])
            ]);
        }else{
             this.filters['userId'] = new OrFilter([
                new Filter(FilterOperation.equals, 'userId', '', this.user.id)
            ]);
        }
       
        
        let params:IParamsCollection = {
            page: { size: 100 },
            sort: ['createdAt'],
            filter: FilterBuilder.fromObject(this.filters).build(),
            include: ['user']
        };
        let response = await firstValueFrom(this.notificationsService.all(params));
        this.notifications = response.data;

        //contamos las notificaciones por tipo
        this.notificationTypes.forEach((type:any) => {
            type.count = this.getNotificationsForType(type).length;
        });
    }

    async executeAction(notification:Notification){
        let parts = notification.link.split(":");
        let actionType = parts[0];
        let action = parts.slice(1).join(":");
        if(actionType=="function"){
            this.run.call(this, "this." + action);
            firstValueFrom(this.notificationsService.markAsReaded(notification));
            this.notificationsService.closeNotifications();
        }else if(actionType=="route"){
            //var url = this.router.createUrlTree([action]);
            //window.open(url.toString(), '_blank');
            window.open(action, '_blank');
            firstValueFrom(this.notificationsService.markAsReaded(notification));
            this.notificationsService.closeNotifications();
        }
    }

    private run(pString:string){
        return eval(pString)
    }

    async openChat(code:string){
        this.chatService.openChatRoom(code);
    }

    //invocado por executeAction desde el Link 'function:openWhatsappChat(...)' de la notificacion
    async openWhatsappChat(phoneNumber:string, caseId?:string){
        this.whatsappChatService.open(phoneNumber, undefined, caseId ? caseId : undefined);
    }

    getNotificationsForType(type:any){
       return this.notifications.filter(
          (notification: Notification) =>
            type.source
              .split(',')
              .includes(notification.source)
        );
    }

    async markAsReaded(notification:Notification){
        await firstValueFrom(this.notificationsService.markAsReaded(notification));
        
        //elimina la notificación de la lista
        let index = this.notifications.indexOf(notification);
        this.notifications.splice(index, 1);

        //borramos la cache del contador de notificaciones
        this.storage.remove("notificationsCountMeta");
    }

    async goToNotifications(){
        this.router.navigate(["/notifications"]);
        this.notificationsService.closeNotifications();
    }
}